// CN-2798: the cancel prompts offer "Notify athlete" only for a lesson that has
// students. Unavailability blocks and edits (the switch is in the form) don't.
export function showsNotifyStudents(data: any): boolean {
  const event = data?.event;
  if (data?.operation !== "delete" || !event) {
    return false;
  }
  const isLesson = event.type === "lesson_schedule" || !event.type;
  const studentIds = event.studentProfileIds ?? event.studentProfiles ?? [];

  return isLesson && studentIds.length > 0;
}

// The value the prompt passes to its actions; anything but an explicit false notifies.
export function notifyStudentsFrom(options?: { notifyStudents?: boolean }): boolean {
  return options?.notifyStudents !== false;
}
